import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=3da4328e&scoped=true&"
import script from "./Contract.vue?vue&type=script&lang=js&"
export * from "./Contract.vue?vue&type=script&lang=js&"
import style0 from "./Contract.vue?vue&type=style&index=0&id=3da4328e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4328e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
